var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    id: "svg6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "0.133333px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      letterSpacing: 0,
      wordSpacing: 0
    },
    x: 7.8726811,
    y: 16.112471,
    id: "text2833"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan2831",
    x: 7.8726811,
    y: 16.112471,
    style: {
      fontSize: "0.133333px"
    }
  }, "Readerum.com")), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.688247px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 12.464459,8.1620763 c 5.488013,0.062247 5.55081,7.8828767 0.563708,7.8942587 -3.5462974,0.0081 -5.2987554,0.0048 -7.638121,-0.01899 C 1.0011733,15.992712 1.0107194,8.2443712 5.2352347,8.2098323 7.4670699,8.1915853 9.9106082,8.1331097 12.464459,8.1620763 Z",
    id: "path2002-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f2f2f2",
      stroke: "#000000",
      strokeWidth: "0.688247px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      fillOpacity: 1
    },
    d: "m 16.854312,6.0463659 c 7.93195,0.022196 8.10172,11.7632271 -0.05501,11.7833451 C 8.6425735,17.84983 9.0633236,6.0245644 16.854312,6.0463659 Z",
    id: "path2002"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.688247px",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m 14.994534,8.7899293 5.384345,3.2364437 -5.366749,3.184244 z",
    id: "path1799"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoplay);
export default __webpack_public_path__ + "static/media/autoplay.2bc19244d9da05fc6ec7bec77cfae468.svg";
export { ForwardRef as ReactComponent };